import { render } from "./TrustSection.vue?vue&type=template&id=2ebfed20"
import script from "./TrustSection.vue?vue&type=script&lang=js"
export * from "./TrustSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__